import moment, { Moment } from "moment";
import { StorageHelper } from "./StorageHelper";

// Chabber merges with Moment A/S - no shifts can be booked on or after this date.
// Mirrors PostingValidationManager.MergerCutoffDate in the .NET API.
export const MERGER_CUTOFF_DATE = moment("2026-12-20", "YYYY-MM-DD");

export function startsAfterMergerCutoff(start: Moment | string): boolean {
  return !moment(start).isBefore(MERGER_CUTOFF_DATE);
}

export function getMergerCutoffMessage(): string {
  let facadeData = new StorageHelper().getFacadeLocalization();
  let languageIso6391Code = "";

  if (facadeData) {
    for (const i of facadeData.knownLanguages) {
      if (i.Id === facadeData.language) {
        languageIso6391Code = i.Iso6391Code;
      }
    }
  }

  if (languageIso6391Code === "da") {
    return "Det er ikke muligt at booke vagter efter den 20 december da Chabber fusioner med Moment A/S. Du burde have modtaget en mail om dette, hvis ikke så kontakt os på team-service@moment.dk";
  }

  return "It is not possible to book shifts after 20 December as Chabber merges with Moment A/S. You should have received an email about it, if not please contact us at team-service@moment.dk";
}
